import config  from './config';
const win: any = window;
const comparVersion = (version: string, supportVersion: string) => {
    if (version) {
        return win.F10Utils.compareVersion(version, supportVersion);
    }
    return false;
}

// 功能是否可用
const showController = (moudle: string) => {
    const app = win.F10Utils.getBroker();
    if (app && config[moudle] && config[moudle][app]) {
        if (win.F10Utils.isIos()) {
            return comparVersion(win.F10Utils.getAppVersion(), config[moudle][app].ios);
        }
        if (win.F10Utils.isAndroid()) {
            return comparVersion(win.F10Utils.getAppVersion(), config[moudle][app].android);
        }
        return false;
    }
    return false;
}

// 协议在哪些客户端可用
const controllerUse = (moudle: string) => {
    const app = win.F10Utils.getBroker();
    if (app && config[moudle] && config[moudle][app]) {
        return true;
    }
    return false;
}

export { showController, controllerUse };
